import { doc, getFirestore, updateDoc } from "firebase/firestore";
import { Status } from "../types";

export const changeBroadcastStatus = async (
  broadcastId: string,
  status: Status,
) => {
  const db = getFirestore();
  const broadcastRef = doc(db, "broadcasts", broadcastId);

  const updateData: {
    status: Status;
    updatedAt: Date;
    isCompleted?: boolean;
  } = {
    status,
    updatedAt: new Date(),
  };

  await updateDoc(broadcastRef, updateData);
};
